import { render } from "./BoardingPlace.vue?vue&type=template&id=33d2be8b&scoped=true"
import script from "./BoardingPlace.vue?vue&type=script&lang=js"
export * from "./BoardingPlace.vue?vue&type=script&lang=js"

import "./BoardingPlace.vue?vue&type=style&index=0&id=33d2be8b&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d2be8b"]])

export default __exports__